import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';




@Injectable()
export class CommonService {

    constructor( private _http: HttpClient) {}

    getJuzgado(): Observable<any[]> {
        return this._http.get<any[]>(`${environment.BACKEND}juzgado/list`);
    }

    

    presignedPost(bucket, fileName, fileType): Observable<any> {
        return this._http.post(`${environment.BACKEND}documentacion/presignedPost`, {
            bucket: bucket,
            fileName: fileName,
            fileType: fileType
        });
    }

}
